import {gql} from "@apollo/client";

// Single report incl. markdown body and the AI chat session. Polled while a
// chat reply is pending — the AI may modify the body, so body and messages
// must refresh together (there are no GraphQL subscriptions).
export const RiskAssessmentReportDetail = gql`
    query RiskAssessmentReportDetail($id: ID!) {
        riskAssessmentReport(id: $id) {
            id
            title
            body
            status
            reportType
            startDate
            endDate
            insert
            reportAssetCount
            file {
                id
                basename
                link
            }
            oneAiChatSession {
                id
                oneAiChatMessageList {
                    total
                    oneAiChatMessages {
                        id
                        content
                        createdAt
                        isAiGenerated
                    }
                }
            }
        }
    }
`;
